import { TextField, Typography } from '@mui/material';

const InputPhoneNumber = (props) => {
  return (
    <TextField
      fullWidth
      variant="outlined"
      autoComplete="off"
      InputProps={{
        maxLength: '10',
        inputMode: 'numeric',
        pattern: '[0-9]*',
        startAdornment: (
          <Typography
            sx={{ width: '120px', fontSize: '1.25rem', fontWeight: '700', color: '#004C60' }}
          >
            {props.text}:
          </Typography>
        ),
      }}
      sx={{
        '& .MuiInputBase-root': {
          fontSize: '1.25rem',
          color: '#004C60',
          backgroundColor: 'white',
          borderRadius: '8px',
          height: '50px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#EEEEEE !important',
        },
        '& .MuiInputBase-input': {
          padding: '15px 5px',
        },
        '& .MuiInputBase-input::placeholder': {
          fontSize: '1.25rem',
        },
        '& .MuiInputBase-input.Mui-disabled': {
          color: '#004C60',
          WebkitTextFillColor: '#004C60',
          cursor: 'not-allowed',
        },
      }}
      {...props}
    />
  );
};
export default InputPhoneNumber;
